<script>
import Layout from '@layouts/default'
import VehicleSearch from '@components/vehicle-search'

export default {
  page: {
    title: 'SubscriptionBenefits',
    meta: [{ name: 'description', content: 'SubscriptionBenefits' }],
    link: [
      {
        rel: 'canonical',
        href: 'https://www.autocheck.com/vehiclehistory/subscription-benefits',
      },
    ],
  },
  components: { Layout, VehicleSearch },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-9 col-12 mt-4 mb-4">
        <h1>VIN and License Plate Checks for Subscribers</h1>
        <hr />
        <h3 class="titleBlue"
          >AutoCheck<sup>®</sup> allows you to access vehicle history reports
          for the duration of your subscription term.</h3
        >
        <p
          >If you are shopping for a vehicle and haven't quite narrowed down
          your choice to just one, our unique multi-reports feature is just
          right for you. &nbsp;For one small fee, you can run a report on every
          vehicle that catches your eye for the duration of your subscription
          term.</p
        >
        <p
          ><strong>Dashboard Access</strong> - Our data-rich Vehicle History
          Report dashboard makes it easier than ever for you to save, compare
          and select the car that's right for you, with easy to read details.</p
        >
        <p
          ><strong>Record Search</strong> - Now there are even more ways to get
          at the vehicle history data that matters to you. Simply search by VIN
          or License Plate. &nbsp;This is an added convenience when the VIN may
          be more difficult to find. &nbsp;Both options offer a powerful yet
          simple search feature.</p
        >
        <VehicleSearch />
      </div>
      <div class="col-md-3 col-12">
        <div class="content-page-right-navigation gray"
          ><BaseLink :to="{ name: 'reports-list' }"
            ><img
              width="161"
              height="152"
              alt="Unlimited Subscription Icon"
              src="images/AutoCheckVHR-Unlimited.png"
          /></BaseLink>
          <ul style="border-top: none;" class="mt-3">
            <li
              ><BaseLink :to="{ name: 'vin-basics' }"
                >Learn more about VINs</BaseLink
              ></li
            >
          </ul></div
        ></div
      >
    </div>
  </Layout>
</template>

<style lang="scss" module>
@import '@design';
</style>
